import classNames from 'classnames'
import { ChangeEvent, forwardRef, ReactNode } from 'react'

type CheckBoxProps = Exclude<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'value'
> & {
  label: ReactNode | string
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export default forwardRef<HTMLInputElement, CheckBoxProps>(function CheckBox(
  { label, labelProps, onChange, ...nativeInputProps }: CheckBoxProps,
  ref,
) {
  const { className, disabled } = nativeInputProps
  return (
    <label
      {...labelProps}
      className={classNames(
        'babu-checkbox-label',
        disabled && 'babu-checkbox-label-disabled',
        labelProps?.className,
      )}>
      <input
        {...nativeInputProps}
        type="checkbox"
        onChange={onChange}
        className={classNames(
          'babu-checkbox-input',
          disabled && 'text-text500',
          className,
        )}
        ref={ref}
      />
      {typeof label === 'string' ? (
        <p
          className={classNames(
            'babu-text-fineprint pl-xs',
            disabled && 'text-text500',
          )}>
          {label}
        </p>
      ) : (
        label
      )}
    </label>
  )
})
